<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>รวมโครงการ{{ location }}</span>
							</div>
							<div class="search-filter">
								<h1>รวมโครงการ</h1>

								<div class="pl-3 pr-5">
									<h2>{{ location }}</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="py-4">
							<h1 class="red--text">
								รวมอสังหาสมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด
							</h1>
							<p class="mt-4 mb-0">
								‘สมุทรปราการ’ เป็นย่านที่อยู่อาศัยที่กำลังพัฒนาและเจริญเติบโตเป็นอย่างมาก เพราะมีทำเลเด่นๆ หลายทำเลที่สามารถเข้าถึงด้วยรถไฟฟ้าและถนนเส้นหลักหลายสาย ไม่ว่าจะเป็น ทำเลบ้านบางนา-ตราด, ทำเลบ้านศรีนครินทร์, ทำเลบ้านพระประแดง, ทำเลบ้านบางบ่อ, ทำเลบ้านสำโรง, ทำเลบ้านเดี่ยวเทพารักษ์, ทำเลบ้านบางพลี, ทำเลบ้านบางปู, ทำเลบ้านแพรกษา, ทำเลบ้านแบริ่ง, ทำเลบ้านพระสมุทรเจดีย์, ทำเลบ้านลาซาล, ทำเลบ้านแถวปู่เจ้าสมิงพราย และทำเลบ้านบางเสาธง
							</p>
							<p>
								ซึ่งทำเลเหล่านี้กลายเป็น HUB ที่อยู่อาศัยแห่งใหม่ทั้งสำหรับคนกรุงเทพฯ ที่อยากเป็นเจ้าของบ้านในราคาไม่แพง และคนในพื้นที่ซึ่งอยู่อาศัยรวมถึงทำงานอยู่ในย่านบริษัทและโรงงานอุตสาหกรรมใหญ่ทั้งแถบโซนบางปูและพระราม 2 ที่อยู่ใกล้เคียง
							</p>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2 class="text-center my-7">
							แนะนำโครงการ<span class="red--text">{{ location }}</span>
						</h2>

						<propertyCarousel
							white
							style="margin-bottom: 60px;"
							:query="{ province }"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'singlehome' } }">
								โครงการบ้านเดี่ยว<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'HOME', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'singlehome' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'singlehome' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'townhome' } }">
								โครงการทาวน์โฮม<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'TOWNHOUSE', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'townhome' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'townhome' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'condo' } }">
								โครงการคอนโด<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'CONDO', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'condo' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'condo' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'shophouse' } }">
								โครงการอาคารพาณิชย์<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'COMMERCIAL_BUILDING', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'shophouse' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'shophouse' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<h2 class="red--text">
							<img
								src="/images/2.0/icon/price-tag-bk.png"
								height="25"
								class="mr-2"
							>
							รวมราคาอสังหาสมุทรปราการ
						</h2>
						<v-card
							class="pa-4 mt-4 mx-md-0 area-content"
							flat
							tile
						>
							<p class="mt-2 mb-0">
								รวมราคา บ้านเดี่ยว, ทาวน์เฮ้าส์, ทาวน์โฮม, คอนโด น่าอยู่จากอสังหาในจังหวัดสมุทรปราการ ในทำเลย่าน เมืองสมุทรปราการ บางพลี บางเสาธง บางบ่อ พระสมุทรเจดีย์ พระประแดง และในย่านอื่น ๆ ที่ใกล้เคียง
							</p>
							<p class="mt-2 mb-0">
								โดยราคาของอสังหาต่าง ๆ จะมีความแตกต่างกันออกไป ตามปัจจัยต่าง ๆ ของอสังหาสมุทรปราการที่คุณเลือก ซึ่งราคาจะขึ้นอยู่กับขนาดของที่พักอาศัยที่คุณเลือก (มากกว่า 50 ตารางเมตร,มากกว่า 80 ตารางเมตร, มากกว่า 150 ตารางเมตร, มากกว่า 200 ตารางเมตร, มากกว่า 300 ตารางเมตร) โดยราคาจะแพงขึ้นตามจำนวนตารางเมตรที่มากขึ้น และการตกแต่งบริเวณบ้าน เช่น ตกแต่งพร้อมอยู่ (แพงที่สุด) ตกแต่งบางส่วน หรือ ห้องเปล่า
							</p>

							<v-expansion-panels flat>
								<v-expansion-panel>
									<v-expansion-panel-header>
										<span>อ่านเพิ่มเติม</span>
										<template v-slot:actions>
											<v-icon color="rgb(237,28,36)">
												$expand
											</v-icon>
										</template>
									</v-expansion-panel-header>
									<v-expansion-panel-content eager>
										<p class="mt-2 mb-0">
											ส่วนปัจจัยต่อมาก็คือ ฟังก์ชั่นการใช้งานของบ้าน ว่ามีกี่ห้องนอน มีกี่ห้องน้ำ โดยส่วนนี้ยิ่งจำนวนห้องเยอะเท่าไร ราคาของอสังหาก็จะยิ่งสูงขึ้นตาม แต่ส่วนมากจะมีกำหนดไว้ดังนี้ 2 ห้องนอน 2 ห้องน้ำ,  3 ห้องนอน 3 ห้องน้ำ, 4 ห้องนอน 4 ห้องน้ำ และ 5 ห้องนอน 5 ห้องน้ำ (สำหรับบ้านเดี่ยวหลังใหญ่ บ้านหรู)
										</p>
										<p class="mt-2 mb-0">
											และสุดท้ายคือ ทำเลที่ตั้งของอสังหา ซึ่งในจังหวัด สมุทรปราการ นั้นที่ดินในแต่ละพื้นที่จะมีราคาไม่เท่ากัน โดยบริเวณที่อสังหามีราคาสูง จะเป็นบริเวณที่มีอาณาเขตติดกับกรุงเทพฯ เช่น บางนา ศรีนครินทร์ แบริ่ง จากนั้นราคาจะลดระดับลงมาตามระยะทางที่ห่างจากกรุงเทพ
										</p>
										<p class="mt-2 mb-0">
											ซึ่งราคาจะมีการแบ่งแยกเป็น Tier ของราคาอสังหาสมุทรปราการไว้ ดังนี้
										</p>
										<ul>
											<li>ราคาต่ำกว่า ฿ 1 ล้าน</li>
											<li>ราคาต่ำกว่า ฿ 2 ล้าน</li>
											<li>ราคาต่ำกว่า ฿ 3 ล้าน</li>
											<li>ราคาต่ำกว่า ฿ 5 ล้าน</li>
											<li>ราคาต่ำกว่า ฿ 10 ล้าน</li>
										</ul>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card>

						<h2 class="red--text mt-8">
							<img
								src="/images/2.0/icon/idea-bk.png"
								height="25"
								class="mr-2"
							>
							วิธีการเลือกอสังหาในจังหวัดสมุทรปราการ
						</h2>
						<v-card
							class="pa-4 mt-4 mx-md-0 area-content"
							flat
							tile
						>
							<h3 class="mt-2">
								ทำเลที่อยู่อาศัยในโซนจังหวัดสมุทรปราการ
							</h3>
							<p class="mt-2 mb-0">
								โซนจังหวัดสมุทรปราการ ถือว่าเป็นจังหวัดในย่านชานเมือง ปริมณฑลที่มีอาณาเขตติดกับกรุงเทพ จึงทำให้มีสถานที่สำคัญ เช่น โรงเรียน มหาวิทยาลัย โรงพยาบาล ชั้นนำ อยู่มากมายไม่ต่างจากกรุงเทพ เช่น โรงเรียนราชวินิตบางแก้ว, โรงเรียนอัสสัมชัญสมุทรปราการ รร.บดินทรเดชา (สิงห์ สิงหเสนี) สมุทรปราการ, The American School Of Bangkok (ASB), โรงเรียน นานาชาติ คอนคอร์เดียน, มหาวิทยาลัยอัสสัมชัญ, มหาวิทยาลัยหัวเฉียว, รพ.บางบ่อ รพ.บางนา 2, รพ.จุฬารัตน์ 5, รพ.รวมชัยประชารักษ์, รพ.กรุงเทพพระประแดง, รพ.เปาโลเมโมเรียลสมุทรปราการ ฯลฯ ซึ่งสถานที่สำคัญเหล่านี้ก็เป็นปัจจัยสำคัญที่จะทำให้คุณเลือกอสังหาในจังหวัดสมุทรปราการ ได้ตรงกับความต้องการของคุณมากที่สุด
							</p>

							<v-expansion-panels flat>
								<v-expansion-panel>
									<v-expansion-panel-header>
										<span>อ่านเพิ่มเติม</span>
										<template v-slot:actions>
											<v-icon color="rgb(237,28,36)">
												$expand
											</v-icon>
										</template>
									</v-expansion-panel-header>
									<v-expansion-panel-content eager>
										<p class="mt-2 mb-0">
											รถไฟฟ้า BTS สายสีเขียว มีสถานีที่อยู่ใกล้เคียงและในพื้นที่สมุทรปราการ (ที่เปิดให้บริการแล้ว) เช่น E13 BTS บางนา, E9 BTS อ่อนนุช, E7 BTS เอกมัย, E12 BTS อุดมสุข, E14 BTS แบริ่ง, E8 BTS พระโขนง, E6 BTS ทองหล่อ, E11 BTS ปุณณวิถี รวมถึงสถานีส่วนต่อขยายใหม่ ที่เพิ่งเปิดให้บริการไปเมื่อเร็ว ๆ นี้อย่างสถานี สำโรง ปู่เจ้า ช้างเอราวัณ เคหะ สายลวด ปากน้ำ แพรกษา โรงเรียนนายเรือ ศรีนครินทร์ เป็นต้น
										</p>
										<p>
											และในอนาคตก็กำลังจะมีอสังหารถไฟฟ้าในโซนจังหวัดสมุทรปราการเกิดขึ้นอีก เช่น รถไฟฟ้า BTS สายสีเขียวช่วงส่วนต่อขยาย บางปู และ รถไฟฟ้าสายสีม่วงใต้
										</p>

										<h3 class="mt-3">
											สถานที่ท่องเที่ยว
										</h3>
										<p class="mt-2 mb-0">
											โซนจังหวัดสมุทรปราการในปัจจุบันได้กลายเป็นแหล่งชุมชนขนาดใหญ่ จึงไม่แปลกที่จะมีห้างสรรพสินค้า หรือ Community Mall มากมาย เช่น เมกา บางนา, อิเกีย บางนา, เซ็นทรัลบางนา, แบงค็อกมอลล์, เมกา ซิตี้ หรือ เดอะฟอเรสเทียส์ ที่เป็นกลุ่มห้างสรรพสินค้าใหม่ ขนาดใหญ่ ที่เต็มไปด้วยร้านค้า ร้านอาหารชั้นนำ
										</p>
										<p class="mt-2 mb-0">
											และยังไม่รวมกับกลุ่มห้างสรรพสินค้าเก่า ที่อยู่ในทำเลโซนสมุทรปราการมาอยู่แล้ว เช่น อิมพีเรียลสำโรง, ซีคอนสแควร์ ศรีนครินทร์ บิ๊กซี ซูเปอร์ สมุทรปราการ, โรบินสัน ไลฟ์สไตล์ สมุทรปราการ และโลตัส สมุทรปราการ เป็นต้น
										</p>
										<p>
											หรือสถานที่ท่องเที่ยวอื่น ๆ ที่เหมาะสำหรับการเปลี่ยนบรรยากาศวันพักผ่อนกับครอบครัว ในโซนสมุทรปราการ ก็มีสถานที่ท่องเที่ยวหลายแห่ง เช่น สถานตากอากาศบางปู บางกระเจ้า เมืองโบราณ พิพิธภัณฑ์ช้างเอราวัณ ก็เป็นอีกกลุ่มสถานที่ท่องเที่ยวที่จะทำให้คุณได้พักผ่อน โดยไม่ต้องเดินทางไปไหนไกล
										</p>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'projects'

import { mapGetters } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyCarousel from '~/components/2.0/property-carousel'

export default {
	// scrollToTop: true,
	name: 'SamutprakanHub',
	layout: 'default_2',

	components: {
		searchForm,
		propertyCarousel,
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let path = context.route.path.split('/')
		if (path[path.length - 1] === '') {
			path.splice(path.length - 1, 1)
		}
		let content = path[1]

		data['title'] = 'รวมอสังหาสมุทรปราการ ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด'
		data['description'] = 'รวมครบ! อสังหาแถวสมุทรปราการ ซื้อ ขาย บ้านเดี่ยว คอนโด บ้านใหม่ บ้านมือสอง ทาวน์เฮ้าส์ ทาวน์โฮม ทุกทำเล พร้อมข้อมูล ราคา'

		await context.store.dispatch('page/initial', data)

		return { path, content }
	},

	data:() => ({
		location: 'สมุทรปราการ',
		locationName: 'samut-prakan',
		province: 2,
		keepAliveActivated: false,
		loading: false,
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		market_selected () {
			if (this.content === 'townhome') {
				return 'TOWNHOUSE'
			} else if (this.content === 'condo') {
				return 'CONDO'
			} else if (this.content === 'shophouse') {
				return 'COMMERCIAL_BUILDING'
			}

			return 'HOME'
		},

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {

	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 9%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
h2.property-sample {
	a {
		text-decoration: none;
		color: rgba(0, 0, 0, 0.87);
	}
}
.area:hover {
	background-color: #3a3a3a;
	color: #fff;
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
